import {LivetickerAssignmentDialog} from 'app/components/match/matchLive/LivetickerAssignmentDialog';
import {RequestErrorHandler} from 'app/components/match/matchLive/LivetickerCommon';
import React, {useState} from 'react';
import {authorizedAPI} from 'app/services/api';
import LivetickerAction from 'app/components/match/LivetickerAction';

const postTicker = slug => {
  return authorizedAPI.post(`/matches/${slug}/ticker`);
};

const LivetickerAvailable = ({fuPaUser, reloadData, matchSlug, openAuthDialog}) => {
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [isAssigningTicker, setIsAssigningTicker] = useState(false);

  const handleTickerAssign = async () => {
    setIsAssigningTicker(true);
    try {
      await postTicker(matchSlug);
      setIsAssigningTicker(false);
      reloadData();
    } catch (error) {
      setError(RequestErrorHandler(error, matchSlug));
      setIsAssigningTicker(false);
    }
  };

  const registerLiveticker = () => {
    if (!fuPaUser?.id) {
      openAuthDialog(
        'Erstelle ein Konto, um den Liveticker bedienen zu können und dir Prämienpunkte zu sichern.',
        "Die Fußballfans, die heute nicht vor Ort dabei sein können, werden's dir danken. 🫶",
        'signup_teaser_liveticker_btn'
      );
      return;
    }

    if (fuPaUser.tickerCount <= 1) {
      setOpen(true);
      return;
    }

    return handleTickerAssign();
  };

  const handleAccept = async () => {
    await handleTickerAssign();
    setOpen(false);
  };

  return (
    <>
      <LivetickerAction
        buttonType='primary'
        descriptiveText='Es ist noch kein Liveticker-Melder eingetragen. 😔'
        error={error}
        isLoading={isAssigningTicker}
        label='Liveticker übernehmen'
        onClick={registerLiveticker}
      />
      <LivetickerAssignmentDialog open={open} onClose={() => setOpen(false)} onAccept={handleAccept} />
    </>
  );
};

export default LivetickerAvailable;
